import React from 'react';
import { displayPriceFormat, getPromotion, } from '../../../utils';
import { useAppSelector } from '../../../redux/hook';
import {
  MODIFY_ORDER_TYPE_PROMOTION,
  ORDER_TYPE_DELIVERY,
  PROMOTION_DELIVERY_FREE,
  PROMOTION_PERCENTAGE,
  UNIT,
} from '../../../constants';
import OrderPromotion from './OrderPromotion';
import Spinner from '../../Spinner';
import SkeletonRow from '../../Skeleton/SkeletonRow.view';

type OrderTotalProps = {
  order: any;
  showFees: boolean;
  isLoading?: boolean
};

export default function OrderTotal({
  order,
  showFees,
  isLoading = false
}: OrderTotalProps) {
  const pendingOrder = useAppSelector(
    (state) => state.pendingOrderReducer
  );
  const {
    managementFee = 0,
    address = {},
    totalPriceOrder = 0,
    totalProductPriceOrder = 0,
    orderType
  } = order?.chargeId ? order : (pendingOrder || {})
  const userServicePrice = address?.deliveryPrice ?? 0;
  const { commande } = order;
  let { promotion } = order;
  if (!commande) {
    promotion = getPromotion(totalProductPriceOrder);
  }
  const displayPriceAsync = price =>
    isLoading
      ? <Spinner />
      : displayPriceFormat(price);

  return (
    <>
      {((showFees && orderType === ORDER_TYPE_DELIVERY) ||
        promotion?.reconversionType ===
        MODIFY_ORDER_TYPE_PROMOTION.CLICK_AND_COLLECT) && (
          <SkeletonRow
            label={'Livraison'}
            amount={promotion && promotion.type === PROMOTION_DELIVERY_FREE
              ? displayPriceFormat(0)
              : displayPriceAsync(userServicePrice)}

            isLoading={isLoading}
          />
        )}
      {showFees && managementFee > 0 && (
        <SkeletonRow
          label={'Frais et Services'}
          amount={displayPriceAsync(managementFee)
          }
          isLoading={isLoading}
        />
      )}
      {promotion && (
        <>
          {promotion.type === PROMOTION_DELIVERY_FREE && (
            <OrderPromotion
              promotion={promotion}
              commande={commande}
              promotionType={'Livraison gratuite'}
              prefix={''}
              isLoading={isLoading}
            />
          )}
          {typeof promotion.type === 'string' &&
            promotion.type.includes(PROMOTION_PERCENTAGE) && (
              <OrderPromotion
                promotion={promotion}
                commande={commande}
                promotionType={promotion.type}
                prefix={'-'}
                isLoading={isLoading}
              />
            )}
          {!isLoading && typeof promotion.type === 'number' && (
            <OrderPromotion
              promotion={promotion}
              commande={commande}
              promotionType={displayPriceFormat(promotion.type)}
              prefix={'-'}
              isLoading={isLoading}
            />
          )}
        </>
      )}
      <div className='row'>
        <SkeletonRow
          label={<h4>Total</h4>}
          amount={
            <div style={{ fontSize: UNIT * 1.3, fontWeight: 'bold' }}>
              {displayPriceAsync(totalPriceOrder)}
            </div>
          }
          isLoading={isLoading}
        />
      </div>
    </>
  );
}
